import { MenuItem } from "../components/menus/Menu";

/**
 * Generate menu items for project statuses dynamically
 * @param statuses Array of status strings
 * @param t Translation function
 * @param navigate Navigate function
 * @param basePath Base path for navigation (e.g., "/projects" or "/projects/all")
 * @returns Array of MenuItem objects
 */
export const generateProjectStatusMenuItems = (
  statuses: string[],
  t: (key: string) => string,
  navigate: (path: string) => void,
  basePath: string = "/projects"
): MenuItem[] => {
  const menuItems: MenuItem[] = [];

  // Always add "All Projects" first
  menuItems.push({
    key: "allProjects",
    text: t("menu.allProjects"),
    icon: null,
    activateClickOnActiveItem: true,
    onClick: () => {
      navigate(basePath);
    }
  });

  // Add status-specific menu items
  statuses.forEach((status) => {
    const menuKey = `${status.toLowerCase()}Projects`;
    menuItems.push({
      key: menuKey,
      text: t(`menu.${menuKey}`) || `${t('menu.projects')} ${t(`enums.projectStatus.${status}`)}`,
      icon: null,
      activateClickOnActiveItem: true,
      onClick: () => {
        navigate(`${basePath}?status=${status}`);
      }
    });
  });

  return menuItems;
};

/**
 * Get menu item key from current route for project status filters
 * @param pathname Current pathname
 * @param search Current search parameters
 * @returns Menu item key string
 */
export const getProjectStatusMenuKey = (pathname: string, search: string): string | null => {
  if (pathname.match(/^\/projects\/\d+$/)) {
    // Project detail page - check status from URL
    const params = new URLSearchParams(search);
    const status = params.get("status");
    return status ? `${status.toLowerCase()}Projects` : "allProjects";
  } else if (pathname.includes("/projects")) {
    // Projects list page
    const params = new URLSearchParams(search);
    const status = params.get("status");
    return status ? `${status.toLowerCase()}Projects` : "allProjects";
  }
  return null;
};
